/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DrillingBrigadeEfficiencyReportRequest,
  ErrorResponse,
  ReportProcessingRequest,
  ValidationErrorResponse,
} from '../models/index';
import {
    DrillingBrigadeEfficiencyReportRequestFromJSON,
    DrillingBrigadeEfficiencyReportRequestToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ReportProcessingRequestFromJSON,
    ReportProcessingRequestToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';

export interface GetBrigadeEfficiencyReportRequest {
    drillingBrigadeEfficiencyReportRequest: DrillingBrigadeEfficiencyReportRequest;
}

/**
 * 
 */
export class MonitoringExcelReportControllerApi extends runtime.BaseAPI {

    /**
     */
    async getBrigadeEfficiencyReportRaw(requestParameters: GetBrigadeEfficiencyReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportProcessingRequest>> {
        if (requestParameters['drillingBrigadeEfficiencyReportRequest'] == null) {
            throw new runtime.RequiredError(
                'drillingBrigadeEfficiencyReportRequest',
                'Required parameter "drillingBrigadeEfficiencyReportRequest" was null or undefined when calling getBrigadeEfficiencyReport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/export/brigade-efficiency`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DrillingBrigadeEfficiencyReportRequestToJSON(requestParameters['drillingBrigadeEfficiencyReportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportProcessingRequestFromJSON(jsonValue));
    }

    /**
     */
    async getBrigadeEfficiencyReport(requestParameters: GetBrigadeEfficiencyReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportProcessingRequest> {
        const response = await this.getBrigadeEfficiencyReportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
